<template>
  <v-container>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer></v-spacer>
            <v-col cols="6" md="3">
            <v-text-field
              v-model="search"
              append-icon="mdi-magnify"
              label="Search"
              single-line
              hide-details
            ></v-text-field>
            </v-col>
          </v-card-title>
          <v-data-table :headers="headers" :items="payinsurancerecords" :search="search">
             <template v-slot:[`item.sessionChoice.paymentDetails.updatedAt`]="{ item }">
              <p v-if="item.sessionChoice !== null && item.sessionChoice.paymentDetails !== null"> {{ item.sessionChoice.paymentDetails.updatedAt | formatdate }} </p>
            </template>
            <template v-slot:[`item.createdAt`]="{ item }">
              <p> {{ item.createdAt | formatdate }} </p>
            </template>
             <template v-slot:[`item.chat.phoneNumber`]="{ item }">
                <router-link :to="`/session/${item.id}/messages`">{{item.chat.phoneNumber}}</router-link>
             </template>
             <template v-slot:[`item.actions`]="{ item }">
                  <v-btn color="primary" small @click="showViewDialog(item)" icon><v-icon>mdi-eye</v-icon></v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="viewDialog" width="40rem" height="50rem">
      <v-card>
        <v-card-title><h4 class="text-center">Payment Details</h4></v-card-title>
        <v-card-text>
          <v-row>
            <v-col cols="6" md="3"> <h4> Created At </h4> </v-col>
            <v-col cols="6" md="8"> <p> {{ record.createdAt | formatdate }} </p></v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="3"> <h4> Phone Number </h4> </v-col>
            <v-col cols="6" md="8"> <p> {{ record.chat.phoneNumber }} </p></v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="3"> <h4> Vehicle Number </h4> </v-col>
            <v-col cols="6" md="8" v-if="record.sessionChoice.carDetails !== null"> <p> {{ record.sessionChoice.carDetails.regNo }} </p></v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="3"> <h4> Vehicle Make </h4> </v-col>
            <v-col cols="6" md="8"> <p v-if="record.sessionChoice.carDetails !== null"> {{ record.sessionChoice.carDetails.make }} </p></v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="3"> <h4> Vehicle Model </h4> </v-col>
            <v-col cols="6" md="8"> <p v-if="record.sessionChoice.carDetails !== null"> {{ record.sessionChoice.carDetails.model }} </p></v-col>
          </v-row>
           <v-row>
            <v-col cols="6" md="3"> <h4> Payment Date </h4> </v-col>
            <v-col cols="6" md="8"> <p v-if="record.sessionChoice.paymentDetails !== null"> {{record.sessionChoice.paymentDetails.updatedAt | formatdate}} </p></v-col>
          </v-row>
          <v-row>
            <v-col cols="6" md="3"> <h4>Payment  Status </h4> </v-col>
            <v-col cols="6" md="8" v-if="record.sessionChoice.paymentDetails !== null"> <p> {{ record.sessionChoice.paymentDetails.status }} </p></v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <v-btn @click="viewDialog = false">CLOSE</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PayforInsuranceRecords',
  data: () => ({
    search: '',
    headers: [
      { text: 'Payment Date', value: 'sessionChoice.paymentDetails.updatedAt' },
      { text: 'Ref No', value: 'sessionChoice.refNo' },
      { text: 'Phone Number', value: 'chat.phoneNumber' },
      { text: 'Vehicle No', value: 'sessionChoice.carDetails.regNo' },
      { text: 'Amount in UGX', value: 'sessionChoice.carDetails.amountPayable' },
      { text: 'Status', value: 'sessionChoice.status' },
      { text: 'Created At', value: 'createdAt' },
      { text: 'Actions', value: 'actions', sortable: false }
    ],
    viewDialog: false,
    record: { sessionChoice: { paymentDetails: { status: '' }, carDetails: { regNo: '', make: '', model: '' } }, chat: {} }
  }),
  computed: mapState({
    payinsurancerecords: state => state.botsession.payinsurancerecords
  }),
  created () {
    this.$store.dispatch('botsession/getPayForInsuranceRecords')
  },
  methods: {
    showViewDialog (item) {
      console.log(item)
      this.viewDialog = true
      this.record = item
    }
  }
}
</script>
